
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta } from "/app/pages/help.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as addXje1sYRbQC2I0lP_45jOFG_IqmdoqYAPuC8pIRXFHJv4IMeta } from "/app/pages/issues/add.vue?macro=true";
import { default as _91id_93zzq8w9yv4OFYDk5agoFKp0WgqO8LpYglbdV7eD5vWiUMeta } from "/app/pages/issues/[id].vue?macro=true";
import { default as registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta } from "/app/pages/auth/register.vue?macro=true";
import { default as changePasswordgd5hGx1GHAT7G_45SlDmEaC_GG_45OJtiJ8vb0ST2eLYOmwMeta } from "/app/pages/changePassword.vue?macro=true";
import { default as verify_45otpBdfx2Y2hxcdSF9dLyVJls4w6Vl8k3ECAqz2Lkrv7PzwMeta } from "/app/pages/auth/verify-otp.vue?macro=true";
import { default as allNTE8kMh6a5n_45sAddViHy8KcgKzfD1RpRGGM_45j83jVigMeta } from "/app/pages/ticketsOverview/all.vue?macro=true";
import { default as late3j7HHAVZTFBdJ3l0ylLMaBUyECP1NxCOKThhw3hlSsEMeta } from "/app/pages/ticketsOverview/late.vue?macro=true";
import { default as changedeg7AcuF32VLAu5v7_zwwlCJoPgNXX99ZpAvlexYIUx8Meta } from "/app/pages/ticketsOverview/changed.vue?macro=true";
import { default as waitingZCwjlncHmDMGIYlTjJaXpu_A1SwFS5gRY6O3BCOZqH8Meta } from "/app/pages/ticketsOverview/waiting.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "help___en",
    path: "/en/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___cs",
    path: "/cs/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___cs",
    path: "/cs/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "issues-add___en",
    path: "/en/issues/add",
    meta: addXje1sYRbQC2I0lP_45jOFG_IqmdoqYAPuC8pIRXFHJv4IMeta || {},
    component: () => import("/app/pages/issues/add.vue")
  },
  {
    name: "issues-add___cs",
    path: "/cs/issues/add",
    meta: addXje1sYRbQC2I0lP_45jOFG_IqmdoqYAPuC8pIRXFHJv4IMeta || {},
    component: () => import("/app/pages/issues/add.vue")
  },
  {
    name: "issues-id___en",
    path: "/en/issues/:id()",
    meta: _91id_93zzq8w9yv4OFYDk5agoFKp0WgqO8LpYglbdV7eD5vWiUMeta || {},
    component: () => import("/app/pages/issues/[id].vue")
  },
  {
    name: "issues-id___cs",
    path: "/cs/issues/:id()",
    meta: _91id_93zzq8w9yv4OFYDk5agoFKp0WgqO8LpYglbdV7eD5vWiUMeta || {},
    component: () => import("/app/pages/issues/[id].vue")
  },
  {
    name: "auth-register___en",
    path: "/en/auth/register",
    meta: registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta || {},
    component: () => import("/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___cs",
    path: "/cs/auth/register",
    meta: registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta || {},
    component: () => import("/app/pages/auth/register.vue")
  },
  {
    name: "changePassword___en",
    path: "/en/changePassword",
    meta: changePasswordgd5hGx1GHAT7G_45SlDmEaC_GG_45OJtiJ8vb0ST2eLYOmwMeta || {},
    component: () => import("/app/pages/changePassword.vue")
  },
  {
    name: "changePassword___cs",
    path: "/cs/changePassword",
    meta: changePasswordgd5hGx1GHAT7G_45SlDmEaC_GG_45OJtiJ8vb0ST2eLYOmwMeta || {},
    component: () => import("/app/pages/changePassword.vue")
  },
  {
    name: "auth-verify-otp___en",
    path: "/en/auth/verify-otp",
    meta: verify_45otpBdfx2Y2hxcdSF9dLyVJls4w6Vl8k3ECAqz2Lkrv7PzwMeta || {},
    component: () => import("/app/pages/auth/verify-otp.vue")
  },
  {
    name: "auth-verify-otp___cs",
    path: "/cs/auth/verify-otp",
    meta: verify_45otpBdfx2Y2hxcdSF9dLyVJls4w6Vl8k3ECAqz2Lkrv7PzwMeta || {},
    component: () => import("/app/pages/auth/verify-otp.vue")
  },
  {
    name: "ticketsOverview-all___en",
    path: "/en/ticketsOverview/all",
    meta: allNTE8kMh6a5n_45sAddViHy8KcgKzfD1RpRGGM_45j83jVigMeta || {},
    component: () => import("/app/pages/ticketsOverview/all.vue")
  },
  {
    name: "ticketsOverview-all___cs",
    path: "/cs/ticketsOverview/all",
    meta: allNTE8kMh6a5n_45sAddViHy8KcgKzfD1RpRGGM_45j83jVigMeta || {},
    component: () => import("/app/pages/ticketsOverview/all.vue")
  },
  {
    name: "ticketsOverview-late___en",
    path: "/en/ticketsOverview/late",
    meta: late3j7HHAVZTFBdJ3l0ylLMaBUyECP1NxCOKThhw3hlSsEMeta || {},
    component: () => import("/app/pages/ticketsOverview/late.vue")
  },
  {
    name: "ticketsOverview-late___cs",
    path: "/cs/ticketsOverview/late",
    meta: late3j7HHAVZTFBdJ3l0ylLMaBUyECP1NxCOKThhw3hlSsEMeta || {},
    component: () => import("/app/pages/ticketsOverview/late.vue")
  },
  {
    name: "ticketsOverview-changed___en",
    path: "/en/ticketsOverview/changed",
    meta: changedeg7AcuF32VLAu5v7_zwwlCJoPgNXX99ZpAvlexYIUx8Meta || {},
    component: () => import("/app/pages/ticketsOverview/changed.vue")
  },
  {
    name: "ticketsOverview-changed___cs",
    path: "/cs/ticketsOverview/changed",
    meta: changedeg7AcuF32VLAu5v7_zwwlCJoPgNXX99ZpAvlexYIUx8Meta || {},
    component: () => import("/app/pages/ticketsOverview/changed.vue")
  },
  {
    name: "ticketsOverview-waiting___en",
    path: "/en/ticketsOverview/waiting",
    meta: waitingZCwjlncHmDMGIYlTjJaXpu_A1SwFS5gRY6O3BCOZqH8Meta || {},
    component: () => import("/app/pages/ticketsOverview/waiting.vue")
  },
  {
    name: "ticketsOverview-waiting___cs",
    path: "/cs/ticketsOverview/waiting",
    meta: waitingZCwjlncHmDMGIYlTjJaXpu_A1SwFS5gRY6O3BCOZqH8Meta || {},
    component: () => import("/app/pages/ticketsOverview/waiting.vue")
  }
]